import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  AnyApiFactory,
  configApiRef,
  createApiFactory,
  alertApiRef,
  AlertApi,
  AlertMessage,
} from '@backstage/core-plugin-api';
import {
  toastApiRef,
  ToastApi,
  ToastApiMessage,
  ToastApiPostResult,
} from '@backstage/frontend-plugin-api';

/**
 * Bridges the new ToastApi (used by newer community plugins like plugin-jenkins@0.31+)
 * to the classic AlertApi available in the legacy frontend system.
 */
class AlertApiToastBridge implements ToastApi {
  constructor(private readonly alertApi: AlertApi) {}

  post(toast: ToastApiMessage): ToastApiPostResult {
    const severity =
      (toast.severity as AlertMessage['severity']) ??
      (toast.status as AlertMessage['severity']) ??
      'info';
    this.alertApi.post({
      message: toast.title,
      severity,
    });
    // Return a no-op result handle — the classic alert API has no dismiss mechanism
    return { dismiss: () => {} };
  }
}

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  ScmAuth.createDefaultApiFactory(),
  // Provide toastApiRef so plugins built against the new frontend system
  // (e.g. @backstage-community/plugin-jenkins@0.31+) work in the classic app.
  createApiFactory({
    api: toastApiRef,
    deps: { alertApi: alertApiRef },
    factory: ({ alertApi }) => new AlertApiToastBridge(alertApi),
  }),
];
